/**
 * strive-pdp.js  (rev 9 — 3 targeted fixes)
 *
 * Fix 1: disableSticky always shows "ADD TO CART" — never the long
 *         disabled text. Visual state is communicated by stick-off class only.
 *
 * Fix 2: _orig.call wrapped in try-catch because Dawn's original
 *         toggleSubmitButton tries to query #sticky-add-to-cart .product-form__submit
 *         which no longer exists in our custom sticky bar — it was throwing a
 *         TypeError and silently killing the enable flow on the second size pick.
 *
 * Fix 3: setTimeout delay increased from 0 → 50ms so Dawn has finished
 *         updating the price DOM before we read it for the button label.
 */

(function () {
  'use strict';

  var TEXT_DISABLED  = 'SELECT A SIZE TO CONTINUE';
  var TEXT_ENABLED   = 'ADD TO CART';
  var TEXT_SOLD_OUT  = 'SOLD OUT';
  var TEXT_UNAVAIL   = 'UNAVAILABLE';
  var EM_DASH        = '\u2014';
  var MID_DOT        = '\u00B7';

  function qs(sel, ctx)  { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function findFieldset(picker, pattern) {
    if (!picker) return null;
    var fieldsets = qsa('fieldset', picker);
    for (var i = 0; i < fieldsets.length; i++) {
      var legend = qs('legend', fieldsets[i]);
      if (legend && pattern.test(legend.textContent.trim())) return fieldsets[i];
    }
    return null;
  }

  function findSizeFieldset(picker) {
    var fs = findFieldset(picker, /size/i);
    if (fs) return fs;
    var r = picker && qs('input[type="radio"][name*="ize"]', picker);
    return r ? r.closest('fieldset') : null;
  }

  function findColourFieldset(picker) {
    var fs = findFieldset(picker, /colou?r|couleur|farbe|kleur/i);
    if (fs) return fs;
    var all = picker ? qsa('fieldset', picker) : [];
    var sf  = findSizeFieldset(picker);
    for (var i = 0; i < all.length; i++) {
      if (all[i] !== sf) return all[i];
    }
    return null;
  }

  function sizeIsSelected(sf) {
    return !!(sf && qs('input[type="radio"]:checked', sf));
  }

  function deselectSize(sf) {
    if (!sf) return;
    qsa('input[type="radio"]', sf).forEach(function (r) { r.checked = false; });
  }

  function selectedColourLabel(colourFieldset) {
    if (!colourFieldset) return '';
    var checked = qs('input[type="radio"]:checked', colourFieldset);
    return checked ? checked.value : '';
  }

  function formatMoney(subunits) {
    var amount  = subunits / 100;
    var priceEl = qs('.price-item--regular, .price__regular .price-item');
    var raw     = priceEl ? priceEl.textContent.trim() : '';
    var symbol  = raw.replace(/[\d\s,.]+.*/, '') || '£';
    return symbol + amount.toFixed(2);
  }

  function readRawPrice() {
    var idInput = qs('form[action="/cart/add"] [name="id"], product-form form [name="id"]');
    if (idInput) {
      var attr = idInput.getAttribute('data-price');
      if (attr && !isNaN(parseInt(attr, 10))) return parseInt(attr, 10);
    }
    if (window.variantData) {
      try {
        var variants = typeof window.variantData === 'string'
          ? JSON.parse(window.variantData) : window.variantData;
        var sel = idInput && idInput.value;
        if (sel) {
          var v = variants.find(function (x) { return String(x.id) === String(sel); });
          if (v && v.price) return v.price;
        }
      } catch (e) {}
    }
    var el = qs('.price--large .price-item--regular, .price-item--regular');
    if (el) {
      var num = parseFloat(el.textContent.replace(/[^\d.]/g, ''));
      if (!isNaN(num)) return Math.round(num * 100);
    }
    return null;
  }

  function readQty() {
    var q = qs('.quantity__input, input[name="quantity"]');
    if (!q) return 1;
    var v = parseInt(q.value, 10);
    return (isNaN(v) || v < 1) ? 1 : v;
  }

  function computeTotal() {
    var unit = readRawPrice();
    return unit ? formatMoney(unit * readQty()) : null;
  }

  function productTitle() {
    var h1 = qs('.product__title h1, h1.product__title, h1');
    return h1 ? h1.textContent.trim().toUpperCase() : '';
  }

  function labelSpan(btn) {
    if (!btn) return null;
    var spans = btn.querySelectorAll('span');
    for (var i = 0; i < spans.length; i++) {
      var cl = spans[i].classList;
      if (!cl.contains('loading-overlay__spinner') &&
          !cl.contains('sold-out-message')         &&
          !cl.contains('visually-hidden')           &&
          !cl.contains('hidden')) return spans[i];
    }
    return spans[0] || null;
  }

  function normaliseDawnText(text) {
    if (!text) return TEXT_DISABLED;
    var t = text.trim().toLowerCase();
    if (t.indexOf('sold') !== -1)    return TEXT_SOLD_OUT;
    if (t.indexOf('unavail') !== -1) return TEXT_UNAVAIL;
    if (t.indexOf('stock') !== -1)   return TEXT_SOLD_OUT;
    return text.toUpperCase();
  }

  /* ── Main CTA ─────────────────────────────────────────────── */
  function disableMain(btn, text) {
    if (!btn) return;
    btn.setAttribute('disabled', 'disabled');
    var sp = labelSpan(btn);
    if (sp) sp.textContent = text || TEXT_DISABLED;
  }

  function enableMain(btn) {
    if (!btn) return;
    btn.removeAttribute('disabled');
    btn.removeAttribute('aria-disabled');
    var price = computeTotal();
    var sp    = labelSpan(btn);
    if (sp) sp.textContent = price
      ? TEXT_ENABLED + ' ' + EM_DASH + ' ' + price
      : TEXT_ENABLED;
  }

  /* ── Sticky button ────────────────────────────────────────────
     FIX 1: sticky button always shows TEXT_ENABLED ("ADD TO CART").
     Disabled vs enabled is communicated only via stick-off/stick-on.
     The long "SELECT A SIZE TO CONTINUE" text is for the main CTA only. */
  function disableSticky(btn) {
    if (!btn) return;
    btn.disabled    = true;
    btn.className   = 'stick-off';
    btn.textContent = TEXT_ENABLED; // always "ADD TO CART", never the long label
  }

  function enableSticky(btn, labelEl, priceEl, colourFieldset) {
    if (!btn) return;
    btn.disabled    = false;
    btn.className   = 'stick-on';
    btn.textContent = TEXT_ENABLED;
    var price = computeTotal();
    if (priceEl && price) priceEl.textContent = price;
    if (labelEl) {
      var title  = productTitle();
      var colour = selectedColourLabel(colourFieldset).toUpperCase();
      labelEl.textContent = colour
        ? title + ' ' + MID_DOT + ' ' + colour
        : title;
    }
  }

  /* ── Pairs ───────────────────────────────────────────────────
     disableBoth: text only goes to main CTA; sticky always gets
     its own fixed TEXT_ENABLED label via disableSticky().       */
  function disableBoth(mainBtn, stickyBtn, text) {
    disableMain(mainBtn, text);
    disableSticky(stickyBtn);          // FIX 1: no text forwarded to sticky
  }

  function enableBoth(mainBtn, stickyBtn, labelEl, priceEl, colourFieldset) {
    enableMain(mainBtn);
    enableSticky(stickyBtn, labelEl, priceEl, colourFieldset);
  }

  /* ── Sticky scroll — direction based ─────────────────────── */
  function initScroll(stickyBar, mainBtn) {
    if (!stickyBar || !mainBtn) return;
    stickyBar.style.display = 'none';
    var lastY = window.pageYOffset;
    window.addEventListener('scroll', function () {
      var currentY      = window.pageYOffset;
      var scrollingDown = currentY > lastY;
      lastY = currentY;
      var btnAboveViewport = mainBtn.getBoundingClientRect().bottom < 0;
      stickyBar.style.display = (scrollingDown && btnAboveViewport) ? 'block' : 'none';
    }, { passive: true });
  }

  /* ── Main init ───────────────────────────────────────────── */
  function init() {
    var productForm   = qs('product-form');
    var variantPicker = qs('variant-radios, variant-selects');
    var stickyBar     = qs('#sticky-add-to-cart');

    if (!productForm) return;

    var mainBtn       = qs('.product-form__submit', productForm);
    var variantId     = qs('form [name="id"]', productForm);
    var stickyBtn     = qs('#strive-sticky-btn');
    var stickyLabelEl = qs('#strive-sticky-label');
    var stickyPriceEl = qs('#strive-sticky-price');
    var qtyInput      = qs('.quantity__input, input[name="quantity"]');

    if (!mainBtn) return;

    var sizeFieldset   = findSizeFieldset(variantPicker);
    var colourFieldset = findColourFieldset(variantPicker);

    /* 1 — Deselect SIZE radios only on load */
    deselectSize(sizeFieldset);
    if (variantPicker) {
      qsa('select', variantPicker).forEach(function (sel) {
        if (/size/i.test(sel.name || sel.id || '')) {
          if (!sel.querySelector('option[value=""]')) {
            var opt = document.createElement('option');
            opt.value = ''; opt.textContent = 'Select a size';
            opt.setAttribute('disabled', '');
            opt.setAttribute('selected', '');
            opt.setAttribute('hidden', '');
            sel.insertBefore(opt, sel.firstChild);
          }
          sel.value = '';
        }
      });
    }

    /* 2 — Initial disabled state */
    disableBoth(mainBtn, stickyBtn);

    /* 3 — Sticky scroll */
    initScroll(stickyBar, mainBtn);

    /* 4 — Sticky click → delegate to main form submit */
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (!stickyBtn.disabled) {
          var submit = qs('.product-form__submit', productForm);
          if (submit && !submit.disabled) submit.click();
        }
      });
    }

    /* 5 — Quantity change */
    function onQtyChange() {
      if (sizeIsSelected(sizeFieldset)) {
        enableBoth(mainBtn, stickyBtn, stickyLabelEl, stickyPriceEl, colourFieldset);
      }
    }
    if (qtyInput) {
      qtyInput.addEventListener('change', onQtyChange);
      qtyInput.addEventListener('input',  onQtyChange);
    }
    var qtyWrapper = qs('quantity-input');
    if (qtyWrapper) qtyWrapper.addEventListener('change', onQtyChange);

    /* 6 — Patch Dawn's toggleSubmitButton
       FIX 2: wrap _orig in try-catch because Dawn's original code does
               document.querySelector('#sticky-add-to-cart .product-form__submit')
               which is null in our custom sticky bar and throws a TypeError,
               silently killing the enable flow on the second size pick.
       FIX 3: setTimeout increased to 50ms so Dawn finishes updating the
               price element in the DOM before we read it for the label.   */
    customElements.whenDefined('product-form').then(function () {
      var proto = Object.getPrototypeOf(productForm);
      if (!proto || typeof proto.toggleSubmitButton !== 'function') return;
      var _orig = proto.toggleSubmitButton;

      productForm.toggleSubmitButton = function (disable, text) {
        try {
          _orig.call(this, disable, text); // FIX 2: crash-safe
        } catch (e) {
          // Dawn threw because it couldn't find .product-form__submit
          // in our custom sticky bar — safe to swallow, we manage it below
        }

        if (disable) {
          var label = text ? normaliseDawnText(text) : TEXT_DISABLED;
          disableBoth(mainBtn, stickyBtn, label);
        } else {
          setTimeout(function () { // FIX 3: 50ms — wait for price DOM update
            if (sizeIsSelected(sizeFieldset)) {
              enableBoth(mainBtn, stickyBtn, stickyLabelEl, stickyPriceEl, colourFieldset);
            } else {
              deselectSize(sizeFieldset);
              disableBoth(mainBtn, stickyBtn);
            }
          }, 50);
        }
      };
    });

    /* 7 — Variant picker change */
    if (variantPicker) {
      variantPicker.addEventListener('change', function (e) {
        var isInsideSize = sizeFieldset && sizeFieldset.contains(e.target);
        if (!isInsideSize) deselectSize(sizeFieldset);
        setTimeout(function () {
          if (sizeIsSelected(sizeFieldset)) {
            enableBoth(mainBtn, stickyBtn, stickyLabelEl, stickyPriceEl, colourFieldset);
          } else {
            disableBoth(mainBtn, stickyBtn);
          }
        }, 80);
      });
    }
    document.body.classList.remove('strive-loading');
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

})();